import {
    CLEAR_SHIFT,
    CLEAR_SHIFT_DATA,
    FETCH_SHIFTS,
    FETCH_SHIFTS_CONFIG,
    LIST_SHIFTS,
    LIST_SHIFTS_CONFIG
} from "./types";
import _ from "lodash";
import {getTimeN} from "../../../utility/DateUtils";

const init = {
    isLoading: false,
    filter: {},
    list: [],
    listConfig: [],
    rows: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_SHIFTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_SHIFTS:
            return {
                ...state,
                isLoading: false,
                list: payload,
                rows: _.map(payload, shift => (
                    {
                        ...shift,
                        stoppedAAt: getTimeN(shift.stoppedAAt),
                        stoppedLoAt: getTimeN(shift.stoppedLoAt),
                        stoppedPostAt: getTimeN(shift.stoppedPostAt)
                    }
                ))
            };

        case FETCH_SHIFTS_CONFIG:
            return {
                ...state,
                isLoading: true
            };
        case LIST_SHIFTS_CONFIG:
            return {
                ...state,
                isLoading: false,
                listConfig: payload
            };
        case CLEAR_SHIFT:
            return {
                ...init
            };
        case CLEAR_SHIFT_DATA:
            return {
                ...state,
                isLoading: false,
                list: [],
                rows: []
            };
        default:
            return state;
    }
}